import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { Group } from "@domain/group/group";
import { useDisbursementLists } from "@domain/wallet/hook";
import { useIsMobile } from "@utils/hooks";
import { ClosableModal } from "@ui/modals/closableModal";
import { mobile } from "@ui/styles/utils";
import { DisbursementList } from "@ui/components/wallet/disbursementList";
import { DisbursementTable } from "@ui/components/wallet/disbursementTable";

interface SeeMoreDisbursementModalProps extends React.HTMLAttributes<HTMLDivElement> {
	close: () => void;
	shareroom: Group;
}

export const SeeMoreDisbursement: React.FC<SeeMoreDisbursementModalProps> = ({ shareroom, close }) => {
	const { result: disbursementList } = useDisbursementLists(shareroom.id);
	const isMobile = useIsMobile();
	return (
		<Container close={close} isModalTransaction>
			<ContainerDescription>
				<StyledTitle>{I18n.t("shareroom.dashboard.transactions.cashout.title")}</StyledTitle>
				<StyledDescription>{I18n.t("shareroom.dashboard.transactions.cashout.description")}</StyledDescription>
			</ContainerDescription>
			{isMobile ? (
				<DisbursementList shareroom={shareroom} disbursementList={disbursementList} />
			) : (
				<DisbursementTable shareroom={shareroom} disbursementList={disbursementList} />
			)}
		</Container>
	);
};
const Container = styled(ClosableModal)`
	display: flex;
`;

const ContainerDescription = styled.div`
	margin-left: 39px;
	@media ${mobile} {
		margin-left: 0px;
		margin-bottom: 30px;
	}
`;

const StyledTitle = styled.div`
	font-weight: 600;
	font-size: 20px;
	line-height: 26px;
	@media ${mobile} {
		font-size: 16px;
		line-height: 26px;
	}
`;

const StyledDescription = styled.div`
	font-weight: 400;
	font-size: 14px;
	line-height: 26px;
	@media ${mobile} {
		font-size: 10px;
		line-height: 16px;
	}
`;
